const list = {
  path: 'contract',
  component: resolve => require(['@/pages/admin/platform/contract'], resolve)
}

export default list
